import request, { download } from "@/utils/request";
import { queryFileList } from "@/api/system/file.js";
import { ORIGIN_SEND_ANALYSIS_ENUM } from "@/enums/sample.js";

// 获取送样单列表 - 订单中心
export function getOrderList(data) {
  return request({
    url: "/produce/deliverysample/order/list",
    method: "POST",
    data
  });
}

// 获取送样单列表 - 营销中心
export function getMarketOrderList(data) {
  return request({
    url: "/produce/deliverysample/order/listForSale",
    method: "POST",
    data
  });
}

// 通过合同获取用户列表
export function getCustomerListByContractId(contractId) {
  return request({
    url: `/system/user/adminUser/queryByCrmContractId/${contractId}`,
    method: "GET"
  });
}

export function getOrderListByContractId(data) {
  return request({
    url: "/produce/deliverysample/order/getOrderListByContractId",
    method: "POST",
    data
  });
}

/**
 * @description 根据订单号来查询订单详情
 * @deprecated
 * @param orderNum
 * @returns {Promise<*>}
 */
export async function getOrderDetail(orderNum) {
  return request({
    url: `/produce/deliverysample/order/getOrderInfoByOrderNum/${orderNum}`,
    method: "GET"
  });
}

//  根据订单号来查询订单详情
export async function getOrderDetailById(orderId) {
  return request({
    url: `/produce/deliverysample/order/getOrderInfoById/${orderId}`,
    method: "GET"
  });
}
//  根据订单ID删除送样单
export async function deleteOrderSample(orderId) {
  return request({
    url: `/produce/deliverysample/order/${orderId}`,
    method: "DELETE"
  });
}

//  根据订单号来查询送样单进展
export async function getSampleProgressDetailById(data) {
  return request({
    url: "/produce/deliverysample/orderSample/progress/list",
    method: "POST",
    data
  });
}

//  更新送样单
export async function updateDeliveryOrder(data) {
  return request({
    url: "/produce/deliverysample/order",
    method: "PUT",
    data
  });
}

//  查询物流的文件列表
export function queryLogisticsFileList(logisticsId) {
  return queryFileList(
    Object.assign(
      {},
      {
        tableName: "bn_sc_order_logistics",
        relationType: 1,
        recordId: logisticsId
      }
    )
  );
}

// 查询订单审批驳回的图片
export function queryAuditRejectFileList(logId) {
  return queryFileList(
    Object.assign(
      {},
      {
        tableName: "bn_sys_audit_log",
        relationType: 1,
        recordId: logId
      }
    )
  );
}

export function auditOrder(data) {
  return request({
    url: "/produce/deliverysample/order/customerOrderSubmitAudit",
    method: "PUT",
    data
  });
}

export function passAudit(data) {
  return request({
    url: "/produce/deliverysample/order/customerOrderPassAudit",
    method: "PUT",
    data
  });
}

export function revokeAudit(data) {
  return request({
    url: "/produce/deliverysample/order/customerOrderRevokeAudit",
    method: "PUT",
    data
  });
}

export function rejectAudit(data) {
  return request({
    url: "/produce/deliverysample/order/customerOrderRejectAudit",
    method: "PUT",
    data
  });
}

//  订单中心-提交仓库审核
export function submitStoreAudit(data) {
  return request({
    url: "/produce/deliverysample/order/customerOrderSubmitStoreAudit",
    method: "PUT",
    data
  });
}

//  订单中心-撤销仓库审核
export function revokeStoreAudit(data) {
  return request({
    url: "/produce/deliverysample/order/customerOrderRevokeStoreAudit",
    method: "PUT",
    data
  });
}

//  订单中心-通过仓库审核
export function passStoreAudit(data) {
  return request({
    url: "/produce/deliverysample/order/customerOrderPassStoreAudit",
    method: "PUT",
    data
  });
}

//  订单中心-驳回仓库审核
export function rejectStoreAudit(data) {
  return request({
    url: "/produce/deliverysample/order/customerOrderRejectStoreAudit",
    method: "PUT",
    data
  });
}

// 送样单批量导入 —— 下载
export function downloadSampleTemplate({ sampleType, fileName, cDnaType }) {
  return download(
    `/produce/deliverysample/orderSample/downloadSampleTemplate/${sampleType}${cDnaType ? `/${cDnaType}` : ""}`,
    {},
    fileName,
    {},
    { isFormDataFormat: false, method: "post" }
  );
}

//  时空组学-试剂耗材申请 —— 新增
export function addConsumableDelivery(data) {
  return request({
    url: "/produce/deliverysample/consumableDelivery",
    method: "POST",
    data
  });
}

//  送样单批量导入 —— 上传
export function uploadSampleTemplate(params, formData) {
  let url = "";
  switch (params.sendSampleType + "") {
    case ORIGIN_SEND_ANALYSIS_ENUM.组织:
    case ORIGIN_SEND_ANALYSIS_ENUM.核酸:
      url = "/produce/deliverysample/orderSample/uploadSampleTemplate";
      break;
    case ORIGIN_SEND_ANALYSIS_ENUM.文库:
      url = "/produce/deliverysample/orderSampleLibrary/uploadSampleTemplate";
      break;
    case ORIGIN_SEND_ANALYSIS_ENUM.单细胞:
    case ORIGIN_SEND_ANALYSIS_ENUM.单细胞cDNA:
      url = "/produce/deliverysample/orderSampleSingleCell/uploadSampleTemplate";
      break;
    case ORIGIN_SEND_ANALYSIS_ENUM["空间转录组(组织)"]:
      url = "/produce/deliverysample/orderSampleSpatialTranscriptome/uploadSampleTemplate";
      break;
    default:
      throw new Error("未知的样本类型，无法上传");
  }

  for (let key in params) {
    formData.append(key, params[key]);
  }
  return request({
    url,
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data"
    },
    data: formData
  });
}

/**
 * @returns {*}
 */
export function exportPendingAuditOrders(param) {
  return download(
    "/produce/deliverysample/order/exportPendingAudit",
    param,
    "送样单待审核列表.xlsx",
    {},
    { isFormDataFormat: false }
  );
}
